var StorageManagerActionTypes;
(function (StorageManagerActionTypes) {
    StorageManagerActionTypes["ADD_FILES"] = "ADD_FILES";
    StorageManagerActionTypes["CLEAR_FILES"] = "CLEAR_FILES";
    StorageManagerActionTypes["QUEUE_FILES"] = "QUEUE_FILES";
    StorageManagerActionTypes["SET_STATUS"] = "SET_STATUS";
    StorageManagerActionTypes["SET_PROCESSED_FILE_KEY"] = "SET_PROCESSED_FILE_KEY";
    StorageManagerActionTypes["SET_STATUS_UPLOADING"] = "SET_STATUS_UPLOADING";
    StorageManagerActionTypes["SET_UPLOAD_PROGRESS"] = "SET_UPLOAD_PROGRESS";
    StorageManagerActionTypes["REMOVE_UPLOAD"] = "REMOVE_UPLOAD";
})(StorageManagerActionTypes || (StorageManagerActionTypes = {}));

export { StorageManagerActionTypes };
